import { CheckCircle2, XCircle, Gavel } from "lucide-react";

export default function ReadinessCard({ readiness }) {
  if (!readiness) return null;
  const met = readiness.checks.filter((c) => c.ok).length;
  return (
    <div data-testid="readiness-card" className={`rounded-2xl border p-5 ${readiness.ready ? "bg-emerald-50 border-emerald-200" : "bg-card border-border"}`}>
      <div className="flex items-center gap-3">
        <span className={`grid place-items-center h-10 w-10 rounded-xl ${readiness.ready ? "bg-emerald-brand text-white" : "bg-secondary text-navy"}`}><Gavel size={20} /></span>
        <div className="flex-1">
          <p className="font-semibold">{readiness.title}</p>
          <p className="text-xs text-muted-foreground">{met}/{readiness.checks.length} prerequisites met{readiness.ready ? " — paperwork in order" : ""}</p>
        </div>
        <span data-testid="readiness-status" className={`text-xs font-semibold px-2.5 py-1 rounded-full ${readiness.ready ? "bg-emerald-brand text-white" : "bg-amber-100 text-amber-800"}`}>{readiness.ready ? "Ready" : "Gaps"}</span>
      </div>
      <ul className="mt-4 space-y-2">
        {readiness.checks.map((c) => (
          <li key={c.name} data-testid={`readiness-${c.ok ? "ok" : "gap"}`} className="flex items-start gap-2 text-sm">
            {c.ok ? <CheckCircle2 size={16} className="text-emerald-brand mt-0.5 shrink-0" /> : <XCircle size={16} className="text-rose-500 mt-0.5 shrink-0" />}
            <div><span className={c.ok ? "" : "font-medium"}>{c.name}</span>{!c.ok && c.why && <p className="text-xs text-muted-foreground">{c.why}</p>}</div>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-[11px] text-muted-foreground">Informational only — verify against official guidance before serving any notice.</p>
    </div>
  );
}
